/*
 * 選定支援事例 詳細 取得
 */
import { apiGetOne } from '@/actions/ApiBaseActions';
export const API_GET_ONE_CATEGORY_CASE = 'API_GET_ONE_CATEGORY_CASE';
export const API_GET_ONE_CATEGORY_COLUMN = 'API_GET_ONE_CATEGORY_COLUMN';
export const API_GET_ONE_CATEGORY_SEMINAR = 'API_GET_ONE_CATEGORY_SEMINAR';
/**
 * コラム・DL資料テーマ 取得
 */
export const apiGetOneCategoryColumn = (_data, meta) => apiGetOne(API_GET_ONE_CATEGORY_COLUMN, `/category/column_theme`, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
/**
 * セミナーカテゴリー 取得
 */
export const apiGetOneCategorySeminar = (_data, meta) => apiGetOne(API_GET_ONE_CATEGORY_SEMINAR, `/category/seminar_category`, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
/**
 * 選定支援事例カテゴリー 取得
 */
export const apiGetOneCategoryCase = (_data, meta) => apiGetOne(API_GET_ONE_CATEGORY_CASE, `/category/support_example_category`, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
